import * as React from 'react';

import blackIcon from './svg/BlackIcon.svg';
import defaultIcon from './svg/DefaultIcon.svg';
import whiteIcon from './svg/WhiteIcon.svg';
import blackLogo from './svg/BlackLogo.svg';
import officialLogo from './svg/OfficialLogo.svg';
import whiteMountainLogo from './svg/WhiteMountainLogo.svg';
import whiteSnowLogo from './svg/WhiteSnowLogo.svg';
import whiteSnowAludeSignLogo from './svg/WhiteSnowAludeSignLogo.svg';
import milesLogo from './svg/MilesLogo.svg';
import milesBlackLogo from './svg/MilesBlackLogo.svg';
import { classes } from '../../lib';

export type LogotypeProps = {
    type:
        | 'BlackIcon'
        | 'DefaultIcon'
        | 'WhiteIcon'
        | 'BlackLogo'
        | 'OfficialLogo'
        | 'WhiteMountainLogo'
        | 'WhiteSnowLogo'
        | 'WhiteSnowAludeSignLogo'
        | 'MilesLogo'
        | 'MilesBlackLogo';
    clickable?: boolean;
    className?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

const typeToSvg = {
    BlackIcon: blackIcon,
    DefaultIcon: defaultIcon,
    WhiteIcon: whiteIcon,
    BlackLogo: blackLogo,
    OfficialLogo: officialLogo,
    WhiteMountainLogo: whiteMountainLogo,
    WhiteSnowLogo: whiteSnowLogo,
    WhiteSnowAludeSignLogo: whiteSnowAludeSignLogo,
    MilesLogo: milesLogo,
    MilesBlackLogo: milesBlackLogo,
};

export const Logotype = ({
    type,
    clickable,
    className,
    ...props
}: LogotypeProps): JSX.Element => (
    <img
        loading="lazy"
        alt="Logotipo da Alude"
        className={classes(className, clickable && 'pointer')}
        src={typeToSvg[type]}
        {...props}
    />
);
